import React from 'react';
import { Inline, xcss } from '@atlaskit/primitives';
var contentStyles = xcss({
  color: 'color.text.subtle',
  fontSize: '12px',
  fontWeight: '400',
  lineHeight: '16px'
});
var AIIndicatorContainer = function AIIndicatorContainer(_ref) {
  var icon = _ref.icon,
    content = _ref.content,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center",
    alignInline: "start",
    space: "space.050",
    xcss: contentStyles,
    testId: testId
  }, icon, content);
};
export default AIIndicatorContainer;